import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Container, Card, Form, Button, Alert } from "react-bootstrap";
import { useForgotPassword } from "../hooks/useForgotPassword";

function ForgotPassword() {
  const { slug } = useParams();
  const [email, setEmail] = useState("");

  const { mutate, isPending, isSuccess, isError, error } = useForgotPassword();

  function handleSubmit(e) {
    e.preventDefault();
    mutate({ email });
  }

  if (isSuccess) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center min-vh-100"
        style={{ padding: "1rem" }}
      >
        <Card
          className="w-100 text-center shadow-sm"
          style={{ maxWidth: 440 }}
        >
          <Card.Body className="p-4">
            <h5>Revisa tu correo</h5>
            <p className="text-muted mt-2">
              Si el correo está registrado, recibirás un enlace para
              restablecer tu contraseña.
            </p>
            <Link
              to={`/${slug}/login`}
              className="btn btn-outline-primary mt-2"
            >
              Volver a inicio de sesión
            </Link>
          </Card.Body>
        </Card>
      </Container>
    );
  }

  const errorMsg = isError
    ? error?.response?.data?.message || "Error al enviar el correo."
    : null;

  return (
    <Container
      className="d-flex justify-content-center align-items-center min-vh-100"
      style={{ padding: "1rem" }}
    >
      <Card className="w-100 shadow-sm" style={{ maxWidth: 440 }}>
        <Card.Body className="p-4">
          <h4 className="mb-1">¿Olvidaste tu contraseña?</h4>
          <p className="text-muted mb-4">
            Ingresa tu correo y te enviaremos un enlace para restablecerla.
          </p>

          {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}

          <Form onSubmit={handleSubmit} noValidate>
            <Form.Group className="mb-4" controlId="resetEmail">
              <Form.Label>Correo electrónico</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                placeholder="correo@academia.com"
              />
            </Form.Group>

            <Button
              type="submit"
              variant="primary"
              className="w-100"
              disabled={isPending}
            >
              {isPending ? "Enviando…" : "Enviar enlace"}
            </Button>
          </Form>

          <p
            className="text-center mt-3 mb-0"
            style={{ fontSize: "0.875rem" }}
          >
            <Link to={`/${slug}/login`}>Volver a inicio de sesión</Link>
          </p>
        </Card.Body>
      </Card>
    </Container>
  );
}

export { ForgotPassword };
